import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";

//mui components
import { Box, Grid, Modal } from "@mui/material";

//styles
import "./indexV2.css";

//api methods
import {
  CreateOrder,
  cartOfferCalculate,
  completePayment,
  dataRetriveWhenPageRefresh,
  getManagers,
  getOrderAmt,
  getOrderDetails,
  getPaymentStatus,
  orderCancelRequest,
  orderMetricsCreate,
  orderStatusRetry,
  payOrderSplit,
  validateManagerPin,
} from "../../../../../../config/Services";

//context
import { UserContext } from "App";
import { getStoreCurrencySymbol } from "../../../../../../utils/currency";

//react native bridge

//icons
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";

//redux
import { useDispatch, useSelector } from "react-redux";
import { addcoupon } from "../../redux/Actions/couponActions";
import {
  addtoggleMode,
  openProductDetailsSearch,
  setAmtFocus,
} from "../../redux/Actions/paginationActions";
import { getCouponState } from "../../redux/Reducers/couponReducer";
import { getMobilePos } from "../../redux/Reducers/paginationReducer";
import { getManager, getsessionPin } from "../../redux/Reducers/sessionReducer";

//custom hooks
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import useGetDevice from "../../../hooks/useGetDevice";
import usePrint from "../../../hooks/usePrint";

// soft ui components
import SoftBox from "../../../../../../components/SoftBox/index";

//custom components
import Navbar from "layouts/ecommerce/posnavbar/Navbar";
import Spinner from "../../../../../../components/Spinner";
import AddCustomerComponent from "../../../../posnavbar/components/addCustomer";
import GroceryAddCustomerModal from "../../CartAddCustomer/GroceryAddCustomerModal";
import StyledButton from "../custom/StyledButton";
import LoyaltySectionModal from "../loyaltySectionModal/index";
import PaymentCouponModal from "../paymentCouponModal";
import TwoWayCartKeyboard from "../tabModal/tabmodal6";
import ManagerAuthModal from "./components/managerAuth/index";
import PaymentModal from "./components/paymentModal";
import SearchBar from "./components/searchBar";
// GstInvoiceModal removed — GST invoice is now selected via the customer addition screen
// const Navbar = lazy(() => import('layouts/ecommerce/posnavbar/index'));
// const ManagerAuthModal = lazy(() => import('./components/managerAuth/index'));
// const TwoWayCartKeyboard = lazy(() => import('../tabModal/tabmodal6'));
// const SearchBar = lazy(() => import('./components/searchBar'));
// const PaymentModal = lazy(() => import('./components/paymentModal'));
// const LoyaltySectionModal = lazy(() => import('../loyaltySectionModal/index'));
// const AddCustomerComponent = lazy(() => import('../../../../posnavbar/components/addCustomer'));
// const OffersCard = lazy(() => import('../offers/components/offersCard/offersCard'));
// const PaymentCouponModal = lazy(() => import('../paymentCouponModal'));

//images
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import OfferIcon from "assets/images/Offer-icon.png";
import ConfettiExplosion from "react-confetti-explosion";
import addCustomerIcon from "../../../../../../assets/images/Add-icon-1.png";
import couponImg from "../../../../../../assets/images/Coupons.png";
import holdCartIcon from "../../../../../../assets/images/Pause-button.png";
import searchIconCustom from "../../../../../../assets/images/Search.png";
import cashIcon from "../../../../../../assets/images/coin-icon.png";
import cardIcon from "../../../../../../assets/images/mastercard-icon.png";
import upiIcon from "../../../../../../assets/images/upi-icon.png";
import cashNew from "../../../../../../assets/images/cash-new.png";
import cashNewSelected from "../../../../../../assets/images/cash-new-selected.png";
import cardNew from "../../../../../../assets/images/card-new.png";
import cardNewSelected from "../../../../../../assets/images/card-new-selected.png";
import upiNew from "../../../../../../assets/images/upi-new.png";
import upiNewSelected from "../../../../../../assets/images/upi-new-selected.png";
import splitNew from "../../../../../../assets/images/split-new.png";
import splitNewSelected from "../../../../../../assets/images/split-new-selected.png";
import creditNew from "../../../../../../assets/images/credit-new.png";
import creditNewSelected from "../../../../../../assets/images/credit-new-selected.png";
import clearCartIcon from "../../../../../../assets/images/delete-icon.png";
import loyaltyImg from "../../../../../../assets/images/loyalty.png";
import offlineImg from "../../../../../../assets/images/offline-icon.png";
import splitImg from "../../../../../../assets/images/split-icon.png";
import { eventTrackerConstant } from "../../../../../common/event-tracker/event-tracker-constants";
import { eventTracker } from "../../../../../common/event-tracker/eventTracker";
import { normalizeNumber } from "../../Middleware/commonUtils";
import {
  changePrevAddedTime,
  eventTrackerTime,
  incrementManuallyAddedProduct,
  incrementScannedProduct,
  removeProductTimeArray,
  resetState,
  setManuallyRemovedItems,
  setTotalProducts,
} from "../../redux/Actions/eventTracker";
import {
  getEventTimeDetails,
  getFullState,
  getManuallyAddedGtinArray,
  getManuallyAddedProduct,
  getManuallyRemovedItems,
  getProductTimeArray,
  getScannedProduct,
  getTotalProducts,
} from "../../redux/Reducers/eventTrackerReducer";
import { getBatchStat } from "../../redux/Reducers/paginationReducer";
import { OfferListing } from "./components/offerListing";

import Swal from "sweetalert2";
import { getFromLocalStorage } from "../../../../../../utils/localStorageHelpers";
import { DeliveryModal } from "./components/deliveryModal";
import { OfferCheckModal } from "./components/offerCheckModal/index";
import { customEventTrigger } from "../../../../../../analytics";
import { incrementHoldOrdersCount } from "../../redux/Actions/holdOrdersCountActions";
import CouponPopup from "./components/coupons-popup";
import LoyaltyPopupCustom from "./components/loyalty-popup";
import CartRightSidebar from "../CartRightSidebar/CartRightSidebar";
import HoldCartModal from "../HoldCartModal/HoldCartModal";
import HoldOrderDrawer from "../../../../posnavbar/components/HoldOrderDrawer";
import FloatingBottom from "./components/floatingBottombar/FloatingBottom";
import useLoyaltyCouponConfig from "../../../../../../hooks/useLoyaltyCouponConfig";
import { applyRoundOff } from "../../utils/cartUtils";

const newSwal = Swal.mixin({
  customClass: {
    confirmButton: "button button-success",
    cancelButton: "button button-error",
    container: "close-session-swal-container",
  },
  buttonsStyling: false,
});

const GroceryCart = () => {
  //recat router
  const navigate = useNavigate();

  //redux
  const dispatch = useDispatch();
  const isMobilePos = useSelector(getMobilePos);
  const couponData = useSelector(getCouponState);
  const isBatchActive = useSelector(getBatchStat);
  const [isExploding, setIsExploding] = useState(false);
  const [isPricingModeWholesale, setIsPricingModeWholesale] = useState(false);
  const [isSalesOrder, setIsSalesOrder] = useState(
    () => localStorage.getItem("cartOrderType") === "SALES_ORDER"
  );
  const [approveloader, setApproveLoader] = useState(false);
  //custom hoooks
  const isMobile = useGetDevice();
  const showSnackbar = useSnackbar();
  const { startPrint, isPrinting, connectPrinter, isError } = usePrint();

  //useContext
  const {
    color,
    cartId,
    setCartId,
    subTotal,
    setSubTotal,
    cartItems,
    setCartItems,
    setCartTotalQty,
    cartTotalQty,
    total,
    setTotal,
    cgst,
    setCgst,
    sgst,
    setSgst,
    paymentMethod,
    setPaymentMethod,
    setLoyaltyPoints,
    offerFound,
    setOfferFound,
    saleMode,
    setSaleMode,
    setCess,
    cess,
    setCartRefetch,
    setIsLoadingScreen,
    cartBilling,
    setCartBilling,
    taxes,
    setTaxes,
  } = useContext(UserContext);

  //state
  const [customerMobile, setCustomerMobile] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [open, setOpen] = useState(() => {
    const raw = localStorage.getItem("CartId");
    const valid = raw && raw !== "[object Object]" && raw !== "undefined" && raw !== "null";
    return !valid; // open modal if no valid cart
  });
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [amtToBePaid, setAmtToBePaid] = useState("");
  const [amtHeading, setAmtHeading] = useState("");
  const [invoiceId, setInvoiceId] = useState("");
  const [pAMt, setPAmt] = useState("");
  const [enterAmount, setEnterAmount] = useState("");
  const [loyaltyModal, setLoyaltyModal] = useState(false);
  const pendingLoyaltyReopenRef = useRef(false);
  const [couponsModal, setCouponsModal] = useState(false);
  const [holdCartModalOpen, setHoldCartModalOpen] = useState(false);
  const [holdOrderDrawerOpen, setHoldOrderDrawerOpen] = useState(false);
  const [couponsData, setcouponsData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [newLoader, setNewLoader] = useState(false);
  const [paymentSuccessfulLoader, setPaymentSuccessfulLoader] = useState(false);
  const [orderId, setOrderId] = useState("");
  const [adjustCheck, setAdjustCheck] = useState(false);
  const [printerConfig, setPrinterConfig] = useState(
    JSON.parse(localStorage.getItem("printerConfig"))
  );
  const [partialStatus, setPartailStatus] = useState(false);
  const [splitActive, setSplitActive] = useState(false);
  const [paymentLoader, setpaymentLoader] = useState(false);
  const [paymentFailed, setPaymentFailed] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [paymentLoadingModal, setPaymentLoadingModal] = useState(false);
  const [newId, setNewId] = useState("");
  const [paymentCancel, setPaymentCancel] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [amountPaid, setAmountPaid] = useState("0");
  const [amountDue, setAmountDue] = useState("0");
  const [checkOrderSatatus, setOrderStatus] = useState(false);
  const [openPayModal, setOpenPayModal] = useState(false);
  const [singleOrderoffline, setSingleOrderOffline] = useState(false);
  const [newTransId, setNewTransId] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const [offerModal, setOfferModal] = useState(false);
  const [previousAmountPaid, setPreviousAmountPaid] = useState("");
  const [loaderAdj, setLoaderAdj] = useState(false);
  const [manual, setManaul] = useState(false);
  const cashierPin = useSelector(getsessionPin);
  const [transCode, setTransCode] = useState("");
  const [cancelLoader, setCancelLoader] = useState(false);
  const [functionCalled, setFunctionCalled] = useState(false);
  const [cardFunctionCalled, setCardFunctionCalled] = useState(false);
  const [splitFunctionCalled, setSplitFunctionCalled] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [payLoader, setPayLoader] = useState(false);
  const [cashChange, setCashChange] = useState(false);
  const [cancelTrans, setCancelTarsn] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [managerDetails, setManagerDetails] = useState([{}]);
  const [managerModal, setmanagerModal] = useState(false);
  const [cartActive, setCartActive] = useState(false);
  const [offerLoader, setOfferLoader] = useState(false);
  const [isPlacingDelivery, setIsPlacingDelivery] = useState(false);
  const [offerCheckModal, setOfferCheckModal] = useState(false);
  const [offerListData, setOfferListData] = useState(false);
  const [couponText, setCouponText] = useState("");
  const offerCalculationInFlightRef = useRef(false);

  const location = useLocation();

  //event 0rdermetrics values
  const eventTime = useSelector(getEventTimeDetails);
  const productTimeArray = useSelector(getProductTimeArray);
  const totalProducts = useSelector(getTotalProducts);
  const manuallyAddedProducts = useSelector(getManuallyAddedProduct);
  const scannedProducts = useSelector(getScannedProduct);
  const manuallyRemovedItems = useSelector(getManuallyRemovedItems);
  const manuallyAddedGtinArray = useSelector(getManuallyAddedGtinArray);
  const orderMetricDataFullState = useSelector(getFullState);
  const selectedManager = useSelector(getManager);

  const appConfig = JSON.parse(localStorage.getItem("appConfig"));
  const roundOffEnabled = appConfig?.enabledFeatures?.ROUND_OFF;
  const roundOffCeilValue = appConfig?.settings?.ROUND_OFF?.roundOffCeil;
  const roundOffFloorValue = appConfig?.settings?.ROUND_OFF?.roundOffFloor;

  useEffect(() => {
    if (!eventTime.startTimeAdded) {
      const currentTime = new Date().getTime();
      dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
      if (!cartItems.length) {
        const currentTime = new Date().getTime();
        dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
        dispatch(changePrevAddedTime(currentTime));
        const orderMetricData = {
          ...orderMetricDataFullState,
          startTime: currentTime,
          prevAddedProductTime: currentTime,
          startTimeAdded: true,
        };
        localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
      }
    }
  }, [eventTime]);

  // useRef
  const enterAmountRef = useRef(null);

  //local storage
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  // const storeMode = localStorage.getItem("storeMode");
  const storeMode = localStorage.getItem("cartStoreMode");
  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");
  const machinenewId = localStorage.getItem("machineId");
  const sessionId = localStorage.getItem("sessionId");
  const licenseId = localStorage.getItem("licenseId");
  const sessionlocId = localStorage.getItem("locId");
  const daySessionId = localStorage.getItem("daySessionId");
  const CartId = localStorage.getItem("CartId");
  const [openDelivery, setOpenDelivery] = useState(false);
  const loyaltyPoints = getFromLocalStorage("loyaltyPoints");
  const licenseName = getFromLocalStorage("licenseName");
  const [showOffer, setShowOffer] = useState(false);

  const { isLoyaltyEnabled, isCouponEnabled, disableLoyalty, disableCoupon } =
    useLoyaltyCouponConfig({
      isLoyaltyApplied: !!loyaltyPoints,
      isCouponApplied: !!couponData?.couponValue,
    });

  // B2B / GST Sales Orders don't carry a customer uidx, so loyalty can't be
  // fetched or redeemed for them. B2B is a non-restaurant flow only.
  const isB2BOrder = useMemo(
    () => isSalesOrder && localStorage.getItem("retailType") !== "RESTAURANT",
    [isSalesOrder]
  );

  //images
  const failedImgWarning = "https://icon-library.net/images/failed-icon/failed-icon-8.jpg";
  const cancelGif =
    "https://cdn0.iconfinder.com/data/icons/banking-156/60/cancel__delete__payment__card__credit-512.png";

  //variables
  const sessionUidx = retailUserDetails?.uidx;
  const mobileNumber = retailUserDetails?.mobileNumber;
  const firstName = retailUserDetails?.firstName;
  const uidx = retailUserDetails?.uidx;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    height: 450,
    bgcolor: "background.paper",
    border: "2px solid #000",
    borderRadius: "10px",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",
  };

  const couponStyle = useMemo(() => {
    return {
      backgroundColor: color === "dark" ? "#353a50" : "#fff",
      color: color === "dark" ? "white" : "black",
      padding: "2%",
      borderRadius: "10px",
      width: "50%",
      maxWidth: "100vw",
      position: "fixed",
      top: "50%",
      left: "10%",
      transform: "translate(40%, -50%)",
      overflow: "hidden",
      height: "500px",
    };
  }, [color]);

  //final cart amount details
  const amountArray = useMemo(
    () => [
      {
        name: "Tax (GST)",
        mrp: `${getStoreCurrencySymbol()}${normalizeNumber(cgst + sgst + cess)}`,
        check: true,
      },
      {
        name: "Previous order amount",
        mrp: `${getStoreCurrencySymbol()}${pAMt}`,
        check: adjustCheck,
      },
      {
        name: "Sub total",
        mrp: `${getStoreCurrencySymbol()}${normalizeNumber(subTotal)}`,
        check: true,
      },
      {
        name: "Total MRP",
        mrp: `${getStoreCurrencySymbol()}${normalizeNumber(total)}`,
        check: true,
      },
      {
        name: amtHeading,
        mrp: `${getStoreCurrencySymbol()}${Number(amtToBePaid)}`,
        check: adjustCheck,
      },
    ],
    [cgst, sgst, pAMt, adjustCheck, subTotal, amtHeading, amtToBePaid, cess]
  );

  useEffect(() => {
    if (subTotal == "0") {
      setAmtToBePaid("");
      setPAmt("");
    }
  }, [subTotal]);

  useEffect(() => {
    const customerDetails = JSON.parse(localStorage.getItem("customer_details"));

    if (customerDetails) {
      setCustomerMobile(customerDetails.mobileNumber || "");
      setCustomerName(customerDetails.name || "");
    }
  }, []);

  // Sync customer details + sales-order flag from localStorage when grocery customer modal closes
  useEffect(() => {
    if (!open) {
      const customerDetails = JSON.parse(localStorage.getItem("customer_details"));
      if (customerDetails) {
        setCustomerMobile(customerDetails.mobileNumber || "");
        setCustomerName(customerDetails.name || "");
      }
      setIsSalesOrder(localStorage.getItem("cartOrderType") === "SALES_ORDER");
      setIsPricingModeWholesale(localStorage.getItem("cartPricingMode") === "WHOLESALE");
    }
  }, [open]);

  // Restore cart state when a hold cart is retrieved and we navigate back to
  // this same route (component stays mounted, so the mount-only useEffect and
  // useState initialisers don't re-run — we must sync state explicitly).
  useEffect(() => {
    const holdCartData = location?.state?.holdCartData;
    if (!holdCartData) return;

    // Restore B2B sales-order indicator
    setIsSalesOrder(holdCartData?.orderType === "SALES_ORDER");

    // Restore cartId in context so the GST pill condition (isSalesOrder && cartId) passes
    if (holdCartData?.cartId) {
      setCartId(holdCartData?.cartId);
      localStorage.setItem("CartId", holdCartData?.cartId);
    }

    // Restore cart items + totals
    const cartProducts = holdCartData?.cartProducts;
    if (cartProducts?.length > 0) {
      setCartItems(cartProducts.sort((a, b) => b?.modifiedDate?.localeCompare(a?.modifiedDate)));
      setCartTotalQty(holdCartData?.billing?.quantity);
    }
    if (holdCartData?.billing) {
      setCartBilling?.(holdCartData.billing);
      if (Array.isArray(holdCartData.billing.taxes)) setTaxes?.(holdCartData.billing.taxes);
    }

    // Restore customer details
    const customerDetails = JSON.parse(localStorage.getItem("customer_details") || "{}");
    if (customerDetails?.name) setCustomerName(customerDetails?.name);
    if (customerDetails?.mobileNumber) setCustomerMobile(customerDetails?.mobileNumber);

    window.history.replaceState({}, "");
  }, [location?.state?.holdCartData]); // eslint-disable-line react-hooks/exhaustive-deps

  // Restore coupon state from the cart API response (Redux is empty after a
  // page refresh, so the applied coupon must be re-hydrated from the backend)
  const syncCouponFromCart = useCallback(
    (cartData) => {
      const nextCoupon = cartData?.cartCoupon || null;
      if (nextCoupon?.couponValue) {
        dispatch(addcoupon(nextCoupon));
        localStorage.setItem("cartCoupon", JSON.stringify(nextCoupon));
      } else {
        const storedCoupon = localStorage.getItem("cartCoupon");
        const wasCouponApplied =
          !!storedCoupon && storedCoupon !== "undefined" && storedCoupon !== "null";
        dispatch(addcoupon(null));
        localStorage.removeItem("cartCoupon");
        if (wasCouponApplied) {
          showSnackbar("Coupon got removed", "info");
        }
      }
    },
    [dispatch, showSnackbar]
  );

  //get cartItems
  useEffect(() => {
    if (localStorage.getItem("CartId")) {
      let cartId = localStorage.getItem("CartId");
      setLoaderAdj(true);
      dataRetriveWhenPageRefresh(cartId)
        .then((res) => {
          setCartId(res?.data?.data?.data?.cartId);
          const cartProducts = res?.data?.data?.data?.cartProducts;
          if (cartProducts !== null && cartProducts?.length > 0) {
            setCartItems(
              cartProducts.sort((a, b) => b?.modifiedDate.localeCompare(a?.modifiedDate))
            );
            setCartTotalQty(res?.data?.data?.data?.billing?.quantity);
            localStorage.setItem("loyaltyPoints", res?.data?.data?.data?.loyaltyPointsValue);
          } else {
            // Cart exists but has no items yet.
            setCartItems([]);
            setCartTotalQty("0");
            // Only prompt for a customer if one hasn't been assigned yet.
            // If customer_details already has a mobile/uidx the operator already
            // created this cart with a customer — just show the empty cart page.
            const savedCustomer = (() => {
              try {
                return JSON.parse(localStorage.getItem("customer_details"));
              } catch (_) {
                return null;
              }
            })();
            const hasCustomer = !!(savedCustomer?.mobileNumber || savedCustomer?.uidx);
            if (!hasCustomer) {
              setOpen(true);
            }
          }
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing?.sgst);
          setCess(res?.data?.data?.data?.billing?.totalCessAmount);
          setSubTotal(res?.data?.data?.data?.billing?.subtotal);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          const billingFromApi = res?.data?.data?.data?.billing;
          if (billingFromApi) {
            setCartBilling?.(billingFromApi);
            if (Array.isArray(billingFromApi.taxes)) {
              setTaxes?.(billingFromApi.taxes);
            }
          }
          setEnterAmount("");
          setIsButtonDisabled(true);
          setOfferFound(res?.data?.data?.data?.offerProductFound);
          syncCouponFromCart(res?.data?.data?.data);
          // Sync pricing mode from cart API (source of truth for B2B carts)
          const apiPricingMode = res?.data?.data?.data?.pricingMode;
          if (apiPricingMode) {
            setIsPricingModeWholesale(apiPricingMode === "WHOLESALE");
            localStorage.setItem("cartPricingMode", apiPricingMode);
          }
          if (res?.data?.data?.data?.orderId == null) {
            setAdjustCheck(false);
            setLoaderAdj(false);
          } else {
            setAdjustCheck(true);
            getOrderAmt(res?.data?.data?.data?.orderId)
              .then((response) => {
                setLoaderAdj(false);
                setPAmt(response?.data?.data?.orderBillingDetails?.grandTotal);
                setPreviousAmountPaid(response?.data?.data?.baseOrderResponse?.amountPaid);
                setInvoiceId(response?.data.data?.baseOrderResponse?.invoiceId);
                setOrderId();

                let amount =
                  Number(res?.data?.data?.data?.billing?.totalCartValue) -
                  Number(response?.data?.data?.orderBillingDetails?.grandTotal) +
                  Number(response?.data?.data?.baseOrderResponse?.outstandingAmount);

                setAmtToBePaid(Math.abs(amount).toFixed(2));
                if (amount > 0) {
                  setAmtHeading("Payable Amount");
                } else {
                  setAmtHeading("Recievable Amount");
                }
              })
              .catch((err) => {
                setLoaderAdj(false);
              });
          }
        })
        .catch((err) => {
          setLoaderAdj(false);
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          // Cart is gone — clear stale id so the "No Active Cart" banner shows
          localStorage.removeItem("CartId");
          setCartId(null);
          handleOpen();
        });
    }
  }, [location.key]);

  // Register cart refresh so the navbar Refresh button works
  useEffect(() => {
    const refreshCart = () => {
      const currentCartId = localStorage.getItem("CartId");
      if (!currentCartId) return Promise.resolve();
      setIsLoadingScreen(true);
      return dataRetriveWhenPageRefresh(currentCartId)
        .then((res) => {
          const data = res?.data?.data?.data;
          if (!data) return;
          setCartId(data?.cartId);
          if (data?.cartProducts !== null) {
            setCartItems(
              [...data?.cartProducts].sort((a, b) =>
                (b?.modifiedDate || "").localeCompare(a?.modifiedDate || "")
              )
            );
            setCartTotalQty(data?.billing?.quantity);
          } else {
            setCartItems([]);
            setCartTotalQty("0");
          }
          setCgst(data?.billing?.cgst);
          setSgst(data?.billing?.sgst);
          setCess(data?.billing?.totalCessAmount);
          setSubTotal(data?.billing?.subtotal);
          setTotal(data?.billing?.totalCartValue);
          if (data?.billing) {
            setCartBilling?.(data.billing);
            if (Array.isArray(data.billing.taxes)) {
              setTaxes?.(data.billing.taxes);
            }
          }
          setOfferFound(data?.offerProductFound);
          syncCouponFromCart(data);
          // Sync pricing mode from cart API on navbar refresh
          if (data?.pricingMode) {
            setIsPricingModeWholesale(data?.pricingMode === "WHOLESALE");
            localStorage.setItem("cartPricingMode", data?.pricingMode);
          }
        })
        .catch(() => {})
        .finally(() => setIsLoadingScreen(false));
    };
    setCartRefetch(() => refreshCart);
    return () => setCartRefetch(null);
  }, [
    setCartRefetch,
    setCartId,
    setCartItems,
    setCartTotalQty,
    setCgst,
    setSgst,
    setCess,
    setSubTotal,
    setTotal,
    setOfferFound,
    setIsLoadingScreen,
  ]);

  //payment mode
  useMemo(() => {
    if (paymentMethod === "UPI" || paymentMethod === "CARD") {
      setPaymentMode("ONLINE");
    } else {
      setPaymentMode("OFFLINE");
    }
  }, [paymentMethod]);

  //event tracker order edit order metric useEffect

  useEffect(() => {
    if (location?.state?.isOrderEditing) {
      const currentTime = new Date().getTime();
      dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
      dispatch(changePrevAddedTime(currentTime));
      dispatch(setManuallyRemovedItems(0));
      dispatch(setTotalProducts(0));
      dispatch(incrementManuallyAddedProduct(0));
      dispatch(incrementScannedProduct(0));
      dispatch(removeProductTimeArray(0));
      const backupData = {
        ...orderMetricDataFullState,
        startTime: currentTime,
        startTimeAdded: true,
        prevAddedProductTime: currentTime,
        totalProducts: 0,
        manuallyAdded: 0,
        scannedProduct: 0,
        manuallyRemovedItems: 0,
        avgProductAddTime: "",
      };
      localStorage.setItem("orderMetricData", JSON.stringify(backupData));
    }
  }, [location?.state?.isOrderEditing]);

  //new cart
  const handleNewCart = () => {
    localStorage.removeItem("CartId");
    setCartId(null); // sync React context so banner renders immediately
    handleOpen();
  };

  const clrAmountFun = () => setEnterAmount("");
  const handleOpen = useCallback(() => {
    pendingLoyaltyReopenRef.current = false;
    setOpen(true);
  }, []);

  const handleCusClose = useCallback(() => setOpen(false), []);

  /* Track whether the customer modal was opened from a "no cart" error.
   * When true, the modal hides its close button so the operator must
   * add a customer (and create a cart) before returning to products. */
  const [disableCustomerModalClose, setDisableCustomerModalClose] = useState(false);

  useEffect(() => {
    if (!open) setDisableCustomerModalClose(false);
  }, [open]);

  /* Open customer modal programmatically — triggered by showNoCartDialog()
   * so the operator can create a cart immediately after a "no cart" error. */
  useEffect(() => {
    const openCustomerModal = () => {
      setDisableCustomerModalClose(true);
      setOpen(true);
    };
    window.addEventListener("pallet:open-customer-modal", openCustomerModal);
    return () => window.removeEventListener("pallet:open-customer-modal", openCustomerModal);
  }, []);

  const handleLoyaltyModal = useCallback(() => {
    if (isB2BOrder) {
      showSnackbar("Loyalty is currently not available for B2B Orders", "info");
      return;
    }
    customEventTrigger("pos_loyalty_screen");
    setLoyaltyModal(true);
  }, [isB2BOrder, showSnackbar]);

  const handleLoyaltyCustomerAdded = useCallback(() => {
    if (pendingLoyaltyReopenRef.current) {
      pendingLoyaltyReopenRef.current = false;
      setLoyaltyModal(true);
    }
  }, []);

  const handleCloseModal = useCallback(() => setLoyaltyModal(false), []);
  const handleCouponModal = useCallback(() => {
    customEventTrigger("pos_coupons_screen");
    setCouponsModal(true);
  }, []);

  const handleCouponModalClose = useCallback(() => setCouponsModal(false), []);

  const handleOfferModalClose = useCallback(() => setOfferModal(false), []);

  const handleOfferModalOpen = useCallback(() => {
    customEventTrigger("pos_offer_screen");
    setOfferModal(true);
  }, []);

  const handleAddCustomerModalOpen = useCallback(() => {
    customEventTrigger("pos_customer_session_page");
    handleOpen();
  }, []);

  const handleOpenPaymentModal = () => {
    customEventTrigger("pos_payment_page");
    if (!printerConfig) {
      showSnackbar("Please configure printer from Settings > Peripherals", "warning");
      return;
    } else if (cartItems?.length === 0) {
      showSnackbar("Your cart is empty. Please add an item to proceed", "info");
      return;
    }
    if (amtHeading === "Recievable Amount") {
      const roundedAmtToBePaid = Math.round(Number(amtToBePaid));
      setEnterAmount(Number.isFinite(roundedAmtToBePaid) ? roundedAmtToBePaid : "");
    } else {
      setEnterAmount("");
    }
    setOpenPayModal(true);
  };
  const closePaymentModal = useCallback(() => {
    setOpenPayModal(false);
  }, [splitActive, partialStatus]);

  const handleSearchProductModal = () => {
    customEventTrigger("pos_products_screen");
    setSearchOpen(true);
  };
  const closeSearchProductModal = useCallback(() => setSearchOpen(false), []);
  const handleManagerModalClose = useCallback(() => setmanagerModal(false), []);
  const handleManagerModalOpen = useCallback(() => {
    customEventTrigger("pos_change_payment_mode");
    setmanagerModal(true);
  }, []);
  const handleDeliveryPopUp = useCallback(() => setOpenDelivery(true), []);
  const handleCloseDeliveryPopUp = useCallback(() => setOpenDelivery(false), []);
  const handleOpenOfferCheckModal = useCallback(() => setOfferCheckModal(true), []);
  const handleCloseOfferCheckModal = useCallback(() => setOfferCheckModal(false), []);

  useEffect(() => {
    if (
      open ||
      openDelete ||
      loyaltyModal ||
      couponsModal ||
      offerModal ||
      openPayModal ||
      searchOpen ||
      managerModal ||
      isBatchActive ||
      openDelivery
    ) {
      setCartActive(false);
    } else {
      setCartActive(true);
    }
  }, [
    open,
    loyaltyModal,
    couponsModal,
    offerModal,
    openPayModal,
    openDelete,
    searchOpen,
    managerModal,
    isBatchActive,
    openDelivery,
  ]);

  //order creation cash
  const createOrderFun = async () => {
    const parsedEnterAmount = Number(enterAmount);
    if (
      !splitActive &&
      paymentMethod === "CASH" &&
      (!Number.isFinite(parsedEnterAmount) || parsedEnterAmount <= 0)
    ) {
      showSnackbar("Please enter a valid amount to proceed", "error");
      return;
    }
    if ((enterAmount === 0 || enterAmount === "" || enterAmount < 1) && splitActive) {
      showSnackbar("You need to pay atleast 1 Rupee to process this order", "error");
      return;
    }
    // if (
    //   amtHeading == "Recievable Amount" &&
    //   Number(enterAmount) < Math.round(Number(amtToBePaid)) &&
    //   adjustCheck
    // ) {
    //   showSnackbar("Please enter a valid amount to proceed", "error");
    //   setIsButtonDisabled(false);
    //   return;
    // } else

    if (
      amtHeading === "Payable Amount" &&
      Number(enterAmount) < Math.round(Number(amtToBePaid)) &&
      adjustCheck &&
      saleMode == "in-store"
    ) {
      showSnackbar("Please enter a valid amount to proceed", "error");
      setIsButtonDisabled(false);
      return;
    }
    if (
      !splitActive &&
      Number(enterAmount) < Math.round(Number(total)) &&
      !adjustCheck &&
      saleMode == "in-store"
    ) {
      showSnackbar("Please enter a valid amount to proceed", "error");
      setIsButtonDisabled(false);
      return;
    }
    setNewLoader(true);
    setIsPlacingDelivery(true);
    setPaymentSuccessfulLoader(true);
    let cart_ID = localStorage.getItem("CartId");
    const isWhatsapp = JSON.parse(localStorage.getItem("customer_details"))?.whatsapp;
    const change = adjustCheck
      ? (Number(enterAmount) - Math.round(Number(amtToBePaid))).toFixed(2)
      : (Number(enterAmount) - Math.round(Number(total))).toFixed(2);
    let createOrderPayload = {
      sessionId: sessionId,
      licenseId: licenseId,
      ...(splitActive && { paymentType: "SPLIT" }),
      ...(roundOffEnabled && { roundOffCeil: roundOffCeilValue }),
      ...(roundOffEnabled && { roundOffFloor: roundOffFloorValue }),
      licenseName: licenseName,
      machineCode: "CASH",
      cartId: cart_ID,
      paymentMode: storeMode === "OFFLINE" ? "OFFLINE" : "ONLINE",
      paymentMethod: saleMode === "delivery" ? "COD" : paymentMethod,
      inventoryCheck: "NO",
      tender: enterAmount,
      balance: String(Math.abs(change)),
      currentUserName: firstName,
      whatsapp: isWhatsapp,
      amount: enterAmount,
    };
    customEventTrigger(`pos_payment_method`, {
      payment_method: `selected_method_${paymentMethod}`,
    });
    await CreateOrder(createOrderPayload)
      .then((res) => {
        if (!!res?.data?.data?.es) {
          showSnackbar(
            res?.data?.data?.message || "Something went wrong. Please try again.",
            "error"
          );
          setNewLoader(false);
          setPaymentSuccessfulLoader(false);
          setIsPlacingDelivery(false);
          setIsButtonDisabled(false);
          return;
        }
        let orderId = res?.data?.data?.orderResponseModel?.orderId;
        if (splitActive) {
          getOrderDetails(orderId, locId)
            .then((res) => {
              if (res?.data?.data?.baseOrderResponse?.paymentStatus === "PARTIALLY_PAID") {
                showSnackbar(res?.data?.data?.baseOrderResponse?.orderStatus, "success");
                setEnterAmount("");
                setAmountPaid(res?.data?.data?.baseOrderResponse?.amountPaid);
                setAmountDue(res?.data?.data?.baseOrderResponse?.outstandingAmount);
                setNewId(res?.data?.data?.baseOrderResponse?.orderId);
                setPartailStatus(true);
                setNewLoader(false);
              } else if (res?.data?.data?.baseOrderResponse?.paymentStatus === "COMPLETED") {
                setIsPlacingDelivery(false);
                closePaymentModal();
                resetValues();
                navigate(location.state?.returnTo || "/order-completed", { state: { orderId: orderId, change: change } });
                setNewLoader(false);
                setPartailStatus(false);
                setSplitActive(false);
              }
            })
            .catch(() => {
              setNewLoader(false);
            });
        } else {
          if (adjustCheck && orderId) {
            const previousOrderId = localStorage.getItem("OrderId");
            const metaData = {
              previousOrderId: previousOrderId,
              newOrderId: orderId,
              approvedByName: selectedManager?.label,
              approvedBy: selectedManager?.uidx,
            };

            eventTracker({ metaData, eventType: eventTrackerConstant.ORDER_EDITED });
          }
          orderMetricsApiCall();
          closePaymentModal();
          const refund = res?.data?.data?.message;
          const refundValue = Math.round(
            Math.abs(res?.data?.data?.orderResponseModel?.amountToBePaid)
          );
          resetValues();
          navigate(location.state?.returnTo || "/order-completed", {
            state: {
              orderId: orderId,
              change: change,
              isRefund:
                refund === "REFUND_SUCCESSFUL" || refund === "Order Adjusted with Previous Order "
                  ? true
                  : false,
              refundValue: refundValue,
            },
          });
          setNewLoader(false);
          setSplitActive(false);
          setPartailStatus(false);
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setIsButtonDisabled(false);
        setNewLoader(false);
        setIsPlacingDelivery(false);
      });
  };

  const createDebitFun = async () => {
    setModalLoader(true);
    if ((enterAmount === 0 || enterAmount === "" || enterAmount < 1) && splitActive) {
      showSnackbar("You need to pay atleast 1 Rupee to process this order", "error");
      return;
    }

    let cart_ID = localStorage.getItem("CartId");
    const isWhatsapp = JSON.parse(localStorage.getItem("customer_details"))?.whatsapp;
    // const change = Math.round(Number(amtToBePaid));
    let createOrderPayload = {
      sessionId: sessionId,
      licenseId: licenseId,
      ...(splitActive && { paymentType: "SPLIT" }),
      ...(roundOffEnabled && { roundOffCeil: roundOffCeilValue }),
      ...(roundOffEnabled && { roundOffFloor: roundOffFloorValue }),
      licenseName: licenseName,
      machineCode: "CASH",
      cartId: cart_ID,
      paymentMode: storeMode === "OFFLINE" ? "OFFLINE" : "ONLINE",
      paymentMethod: saleMode === "delivery" ? "COD" : paymentMethod,
      inventoryCheck: "NO",
      paymentType: "POS_CREDIT_SALE",
      tender: enterAmount,
      currentUserName: firstName,
      balance:
        paymentMethod === "DEBIT_NOTE" ? "0" : String(Math.abs(Math.round(Number(amtToBePaid)))),
      whatsapp: isWhatsapp,
      ...(paymentMethod === "DEBIT_NOTE" && { subOrderType: "POS_CREDIT_SALE" }),
      amount: paymentMethod === "DEBIT_NOTE" ? Number(amtToBePaid) : Math.round(amtToBePaid),
    };
    customEventTrigger(`pos_payment_method`, {
      payment_method: `selected_method_${paymentMethod}`,
    });
    await CreateOrder(createOrderPayload)
      .then((res) => {
        if (!!res?.data?.data?.es) {
          showSnackbar(
            res?.data?.data?.message || "Something went wrong. Please try again.",
            "error"
          );

          return;
        }
        let orderId = res?.data?.data?.orderResponseModel?.orderId;
        if (splitActive) {
          getOrderDetails(orderId, locId)
            .then((res) => {
              if (res?.data?.data?.baseOrderResponse?.paymentStatus === "PARTIALLY_PAID") {
                showSnackbar(res?.data?.data?.baseOrderResponse?.orderStatus, "success");
                setEnterAmount("");
                setAmountPaid(res?.data?.data?.baseOrderResponse?.amountPaid);
                setAmountDue(res?.data?.data?.baseOrderResponse?.outstandingAmount);
                setNewId(res?.data?.data?.baseOrderResponse?.orderId);
                setPartailStatus(true);
                setNewLoader(false);
              } else if (res?.data?.data?.baseOrderResponse?.paymentStatus === "COMPLETED") {
                setIsPlacingDelivery(false);
                closePaymentModal();
                resetValues();
                navigate(location.state?.returnTo || "/order-completed", { state: { orderId: orderId, change: change } });
                setNewLoader(false);
                setPartailStatus(false);
                setSplitActive(false);
              }
            })
            .catch(() => {
              setNewLoader(false);
            });
        } else {
          if (adjustCheck && orderId) {
            const previousOrderId = localStorage.getItem("OrderId");
            const metaData = {
              previousOrderId: previousOrderId,
              newOrderId: orderId,
              approvedByName: selectedManager?.label,
              approvedBy: selectedManager?.uidx,
            };

            eventTracker({ metaData, eventType: eventTrackerConstant.ORDER_EDITED });
          }
          setModalLoader(false);
          setpaymentLoader(true);
          setPaymentSuccess(true);
          orderMetricsApiCall();
          startPrint({ orderId });
          resetValues();
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setPaymentFailed(true);
        setModalLoader(false);
        setPaymentSuccess(false);
      });
  };

  //payment mode offline for single order
  const handleOffline = () => {
    setSingleOrderOffline(true);
  };

  //order creation upi
  const digitalPaymentFunUPI = () => {
    if ((enterAmount === 0 || enterAmount === "" || enterAmount < 1) && splitActive) {
      showSnackbar("You need to pay atleast 1 Rupee to process this order", "error");
      return;
    }

    customEventTrigger(`pos_payment_method`, {
      payment_method: `selected_method_${paymentMethod}`,
    });
    setModalLoader(true);
    let cart_ID = localStorage.getItem("CartId");
    const machineId = localStorage.getItem("machineId");
    const isWhatsapp = JSON.parse(localStorage.getItem("customer_details"))?.whatsapp;
    const change = adjustCheck
      ? (Number(enterAmount) - Math.round(Number(amtToBePaid))).toFixed(2)
      : (Number(enterAmount) - Math.round(Number(total))).toFixed(2);
    let payload = {
      sessionId: sessionId,
      licenseId: licenseId,
      licenseName: licenseName,
      machineCode: machineId,
      cartId: cart_ID,
      paymentMode: singleOrderoffline
        ? "OFFLINE"
        : storeMode === "OFFLINE" || !machineId
        ? "OFFLINE"
        : "ONLINE",
      paymentMethod: paymentMethod,
      ...(splitActive && { paymentType: "SPLIT" }),
      inventoryCheck: "NO",
      ...(roundOffEnabled && { roundOffCeil: roundOffCeilValue }),
      ...(roundOffEnabled && { roundOffFloor: roundOffFloorValue }),
      tender: enterAmount,
      currentUserName: firstName,
      balance:
        paymentMethod === "CARD" || paymentMethod === "UPI" || paymentMethod === "DEBIT_NOTE"
          ? "0"
          : String(Math.abs(change)),
      whatsapp: isWhatsapp,
      amount: splitActive ? enterAmount : adjustCheck ? Math.abs(amountPaid - total) : total,
    };

    CreateOrder(payload)
      .then((res) => {
        showSnackbar("Payment under progress", "info");
        setModalLoader(false);
        setpaymentLoader(true);
        if (res?.data?.data?.es === 1) {
          showSnackbar(
            res?.data?.data?.message || "Something went wrong. Please try again.",
            "error"
          );
          setModalLoader(false);
          setpaymentLoader(false);
        } else {
          setModalLoader(false);
          setNewId(res?.data?.data?.orderResponseModel?.orderId);
          setNewTransId(res?.data?.data?.orderResponseModel?.transactionCode);
          if (storeMode === "OFFLINE") {
            callGetOrder(res?.data?.data?.orderResponseModel?.orderId);
          } else {
            callPaymentStatus(res?.data?.data?.orderResponseModel?.transactionCode);
          }
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setOpen(false);
        setModalLoader(false);
      });
  };

  const callGetOrder = (orderId, currentRetry) => {
    setPaymentSuccess(false);
    let maxRetries = 95;
    let retry = currentRetry || 0;
    orderStatusRetry(orderId)
      .then((res) => {
        if (
          res?.data?.data?.baseOrderResponse?.paymentStatus === "PAYMENT_PENDING" &&
          retry < maxRetries &&
          res?.data?.data?.baseOrderResponse?.orderStatus === "CREATED"
        ) {
          retry++;
          setPartailStatus(true);
          showSnackbar(res?.data?.data?.baseOrderResponse?.paymentStatus, "success");
          setPaymentLoadingModal(true);
          setTimeout(() => callGetOrder(orderId, retry), 2000 + retry);
        } else if (res?.data?.data?.baseOrderResponse?.paymentStatus === "PAYMENT_CANCELLED") {
          setpaymentLoader(false);
          return;
        } else if (res?.data?.data?.baseOrderResponse?.paymentStatus === "CANCELLED") {
          setpaymentLoader(false);
          return;
        } else if (res?.data?.data?.baseOrderResponse?.paymentStatus === "PARTIALLY_PAID") {
          setPaymentLoadingModal(false);
          showSnackbar(res?.data?.data?.baseOrderResponse?.paymentStatus, "success");
          setAmountPaid(res?.data?.data?.baseOrderResponse?.amountPaid);
          setAmountDue(res?.data?.data?.baseOrderResponse?.outstandingAmount);
          setOrderId(res?.data?.data?.baseOrderResponse?.orderId);
          setPartailStatus(true);
          setEnterAmount("");
          if (splitActive) {
            setPaymentSuccess(false);
            setpaymentLoader(false);
          }
        } else {
          if (retry === maxRetries) {
            setPaymentFailed(true);
          } else if (res?.data?.data?.baseOrderResponse?.orderStatus === "PAYMENT_PENDING") {
            setPaymentLoadingModal(false);
          } else {
            setPaymentFailed(false);
            setPaymentSuccess(true);
            startPrint({ orderId });
            if (adjustCheck && orderId) {
              const previousOrderId = localStorage.getItem("OrderId");
              const metaData = {
                previousOrderId: previousOrderId,
                newOrderId: orderId,
                approvedByName: selectedManager?.label,
                approvedBy: selectedManager?.uidx,
              };

              eventTracker({ metaData, eventType: eventTrackerConstant.ORDER_EDITED });
            }
            orderMetricsApiCall();
            showSnackbar("Payment Success", "success");
            if (storeMode === "OFFLINE") {
              resetValues();
            } else {
              setTimeout(() => {
                resetValues();
                return;
              }, 2000);
            }
          }
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      });
  };

  useEffect(() => {
    if (amtHeading === "Recievable Amount") {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [amtHeading]);

  useEffect(() => {
    let amount = total - pAMt;
    setAmtToBePaid(Math.abs(amount).toFixed(2));

    if (amount > 0) {
      setAmtHeading("Payable Amount");
    } else {
      setAmtHeading("Recievable Amount");
    }
  }, [total, pAMt]);

  useEffect(() => {
    const pressedRef = {};
    const handleKeyDown = (e) => {
      if (pressedRef[e.code]) return; // already handled
      pressedRef[e.code] = true;
      if (e?.key === 6 && e.altKey) {
        e.preventDefault();
        dispatch(openProductDetailsSearch(true));
      } else if (e?.key === 6) {
        e.preventDefault();
        if (cartItems.length < 1) {
          showSnackbar("Add products to the cart to hold.", "info");
        } else {
          setHoldCartModalOpen(true);
        }
      }
      if (e?.key === "=") {
        e.preventDefault();
        dispatch(setAmtFocus(false));
        enterAmountRef?.current?.focus();
      }
      if (e.key === "-") {
        e.preventDefault();
        dispatch(setAmtFocus(true));
        enterAmountRef?.current?.blur();
      }
      if (e.key === "c" && e.altKey) {
        setOfferModal(false);
      }
      if (e.key === "1" && e.ctrlKey) {
        const myPayTab = document.getElementById("btnTab");
        if (myPayTab) {
          e.preventDefault();
          myPayTab?.focus();
        }
      }
      if (e.key === "F4") {
        pendingLoyaltyReopenRef.current = false;
        setOpen(true);
        e.preventDefault();
      }
      if (e.key === "F8") {
        if (!!offerFound) return;
        handleLoyaltyModal();
        e.preventDefault();
      }
      if (e.key === "F1") {
        offerFound
          ? handleOfferCalculate()
          : saleMode === "delivery"
          ? createOrderFun()
          : handleOpenPaymentModal();
        e.preventDefault();
      }
      if (e.key === "F3") {
        handleSearchProductModal();
        e.preventDefault();
      }
      if (e.key === "F10") {
        handleOfferModalOpen();
        e.preventDefault();
      }
      if (e.key === "F9") {
        if (!!offerFound) return;
        handleCouponModal();
        e.preventDefault();
      }
      if (e.key === "F5") {
        handleManagerModalOpen();
        e.preventDefault();
      }
      if (e.key === "F7") {
        e.preventDefault();
        if (!cartItems.length) {
          return;
        }
        deleteCartItem();
      }
      if (e.key === "Escape") {
        handleCloseModal();
        handleCouponModalClose();
        handleOfferModalClose();
        closeSearchProductModal();
        closePaymentModal();
        handleCusClose();
        setmanagerModal(false);
        handleManagerModalClose();
        handleCloseDeliveryPopUp();
      }
    };

    const handleKeyUp = (e) => {
      pressedRef[e.code] = false;
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, [cartItems, offerFound, saleMode]);

  //enter amount by keyboard
  const handleNumberPress = (number) => {
    setSelectedNumber(number);
    setTimeout(() => setSelectedNumber(null), 1000);
  };

  useMemo(() => {
    const handleKeyDown = (event) => {
      const keyPressed = event.key;
      if (/^[0-9]$/.test(keyPressed)) {
        handleNumberPress(Number(keyPressed));
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const checkPayment = () => {
    switch (paymentMethod) {
      case "CASH":
        createOrderFun();
        break;
      case "UPI":
      case "SODEXO":
      case "CARD":
        digitalPaymentFunUPI();
        break;
      case "DEBIT_NOTE":
        createDebitFun();
        break;
      default:
        break;
    }
  };

  // to add payment manaual
  const handleManual = () => {
    setManaul(true);
  };

  //handle orders manually
  const handleManualorders = () => {
    const machineId = localStorage.getItem("machineId");
    setApproveLoader(true);
    let payload = {
      mobile: mobileNumber,
      primaryPassword: cashierPin,
    };
    let completePayload = {
      referenceId: newId,
      transactionCode: newTransId,
      paymentStatus: "COMPLETED",
      amountPaid: splitActive ? enterAmount : total,
      paymentType: "MANUAL",
      paymentMethod: paymentMethod,
      paymentMode: singleOrderoffline
        ? "OFFLINE"
        : storeMode === "OFFLINE" || !machineId
        ? "OFFLINE"
        : "ONLINE",
    };
    validateManagerPin(payload)
      .then((res) => {
        showSnackbar("Success Pin verified", "success");
        completePayment(completePayload)
          .then((res) => {
            if (
              res?.data?.data?.paymentResponseModel?.orderStatus === "PARTIALLY_PAID" ||
              res?.data?.data?.paymentResponseModel?.orderStatus === "PAYMENT_PENDING"
            ) {
              showSnackbar("Partially Paid", "success");
              setApproveLoader(false);
              setPartailStatus(true);
              setPaymentLoadingModal(false);
              setManaul(false);
              setAmountPaid(res?.data?.data?.paymentResponseModel?.amountPaid);
              setAmountDue(res?.data?.data?.paymentResponseModel?.outStandingAmount);
            } else if (
              res?.data?.data?.paymentResponseModel?.orderStatus === "PAID" &&
              res?.data?.data?.paymentResponseModel?.paymentStatus === "COMPLETED"
            ) {
              setApproveLoader(false);
              orderMetricsApiCall();
              showSnackbar("Payment Success", "success");
              startPrint({ orderId: newId });
              setManaul(false);
            }
          })
          .catch((err) => {
            showSnackbar(err?.response?.data?.message || err?.message, "error");
            setPaymentFailed(true);
            setApproveLoader(false);
            setTimeout(() => {
              setCartItems([]);
              setCartTotalQty("0");
              pendingLoyaltyReopenRef.current = false;
              setOpen(true);
            }, 2000);
          });
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setApproveLoader(false);
      });
  };

  // to cancel only the transcation not creating new cart
  const handleTansactionCancel = () => {
    setCancelLoader(true);
    let payload = {
      orderId: newId,
      transactionCode: newTransId,
    };
    orderCancelRequest(payload).then((res) => {
      if (res?.data?.data?.statusModel?.orderStatus === "PAYMENT_CANCELLED") {
        setPaymentLoadingModal(false);
        setCancelLoader(false);
        setPartailStatus(true);
        setEnterAmount("");
      } else if (res?.data?.data?.statusModel?.paymentStatus === "PAYMENT_PENDING") {
        setPaymentLoadingModal(false);
        setCancelLoader(false);
        setPartailStatus(true);
        setEnterAmount("");
        setOrderStatus(true);
        callPaymentStatus(newTransId);
      }
    });
  };

  //split payment intergation
  const handleSplitPayment = () => {
    setSplitActive((prev) => {
      const next = !prev;
      setPaymentMethod("CASH");
      if (!next) {
        setPartailStatus(false);
        setEnterAmount("");
      }
      return next;
    });
  };

  useEffect(() => {
    if (cartItems?.length === 0) {
      localStorage.removeItem("loyaltyPoints");
    }
  }, [cartItems]);

  const handlesplitInputChange = (e) => {
    const valueInput = e.target.value;
    setEnterAmount(valueInput);
  };

  //partila payment
  const partialCompletePayment = () => {
    customEventTrigger("pos_partial_payment");
    if ((enterAmount === 0 || enterAmount === "" || enterAmount < 1) && paymentMethod === "CASH") {
      showSnackbar("Please enter a valid amount", "error");
      return;
    }
    if ((enterAmount === 0 || enterAmount === "" || enterAmount < 1) && splitActive) {
      showSnackbar("You need to pay atleast 1 Rupee to process this order", "error");
      return;
    }
    setCancelLoader(false);
    setPayLoader(true);
    const machineId = localStorage.getItem("machineId");
    const roundDueAmount = (amount) => applyRoundOff(amount, roundOffFloorValue);
    const change = adjustCheck
      ? (Number(enterAmount) - roundDueAmount(Number(amountDue) || Number(amtToBePaid))).toFixed(2)
      : (Number(enterAmount) - roundDueAmount(Number(amountDue) || Number(total))).toFixed(2);
    let payload = {
      orderId: newId,
      ...(splitActive && { paymentType: "SPLIT" }),
      ...(roundOffEnabled && { roundOffCeil: roundOffCeilValue }),
      ...(roundOffEnabled && { roundOffFloor: roundOffFloorValue }),
      amount: splitActive ? enterAmount : adjustCheck ? total - amtToBePaid : total,
      paymentMethod: paymentMethod,
      paymentMode: singleOrderoffline
        ? "OFFLINE"
        : storeMode === "OFFLINE" || !machineId
        ? "OFFLINE"
        : "ONLINE",
      licenseId: licenseId,
      sessionId: sessionId,
      loggedInUserId: uidx,
      machineCode: machineId,
      tender: enterAmount,
      balance: String(Math.abs(change)),
    };

    // if (paymentMethod === "CASH") {
    // payload.tender = enterAmount;
    // payload.balance = String(Math.abs(change));
    // setpaymentLoader(false);
    // } else {
    //   setpaymentLoader(true);
    // }

    payOrderSplit(payload)
      .then((res) => {
        setPaymentLoadingModal(true);
        if (res?.data?.data?.es === 1) {
          showSnackbar(res?.data?.data?.message, "error");
        }

        if (res?.data?.data?.paymentStatus === "COMPLETED") {
          setPaymentFailed(false);
          setPaymentSuccess(true);
          setpaymentLoader(true);
          startPrint({
            orderId: newId,
          });
          if (adjustCheck && orderId) {
            const previousOrderId = localStorage.getItem("OrderId");
            const metaData = {
              previousOrderId: previousOrderId,
              newOrderId: orderId,
              approvedByName: selectedManager?.label,
              approvedBy: selectedManager?.uidx,
            };

            eventTracker({ metaData, eventType: eventTrackerConstant.ORDER_EDITED });
          }
          orderMetricsApiCall();
          showSnackbar("Payment Success", "success");
          setTimeout(() => {
            resetValues();
            return;
          }, 2000);
        } else if (
          res?.data?.data?.paymentStatus === "PARTIALLY_PAID" ||
          res?.data?.data?.paymentStatus === "PAYMENT_PENDING" ||
          res?.data?.data?.paymentStatus === "PAYMENT_CANCELLED"
        ) {
          if (
            (paymentMethod === "CARD" || paymentMethod === "UPI" || paymentMethod === "SODEXO") &&
            storeMode === "ONLINE"
          ) {
            setPaymentLoadingModal(true);
            setNewTransId(res?.data?.data?.transactionCode);
            callPaymentStatus(res?.data?.data?.transactionCode);
          }
          if (storeMode === "OFFLINE") callGetOrder(res?.data?.data?.orderId);
          setPaymentLoadingModal(false);
          setCashChange(true);
          showSnackbar(res?.data?.data?.orderStatus, "success");
          setEnterAmount("");
          setAmountPaid(res?.data?.data?.amountPaid);
          setAmountDue(res?.data?.data?.amountToBePaid);
          setPayLoader(false);
        } else {
          setPayLoader(false);
          setPaymentLoadingModal(false);
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setPayLoader(false);
        setCashChange(false);
      });
  };

  //paymentStatus
  const callPaymentStatus = (transId, currentRetry) => {
    let maxRetries = 95;
    let retry = currentRetry || 0;
    setEnterAmount(enterAmount);
    if (storeMode === "OFFLINE") {
      callGetOrder(newId);
      return;
    }
    getPaymentStatus(transId)
      .then((res) => {
        if (
          res?.data?.data?.paymentResponseModel?.paymentStatus === "PAYMENT_INITIATED" &&
          retry < maxRetries
        ) {
          retry++;
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "success");
          setPaymentLoadingModal(true);
          setpaymentLoader(true);
          setPaymentSuccess(false);
          setTimeout(() => callPaymentStatus(transId, retry), 2000 + retry);

          if (retry === maxRetries) {
            setPaymentFailed(true);
            setCancelTarsn(true);
          }
        } else if (res?.data?.data?.paymentResponseModel?.paymentStatus === "COMPLETED") {
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "success");
          callGetOrder(res?.data?.data?.paymentResponseModel?.orderId);
        } else if (
          res?.data?.data?.paymentResponseModel?.paymentStatus === "PAYMENT_CANCELLED" ||
          res?.data?.data?.paymentResponseModel?.paymentStatus === "CANCELLED"
        ) {
          retry === maxRetries;
          setPaymentLoadingModal(false);
          setCancelLoader(false);
          setPartailStatus(true);
          setEnterAmount("");
          setpaymentLoader(false);
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "error");

          // retry===1000
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      });
  };

  const resetValues = () => {
    setPaymentLoadingModal(false);
    setCartItems([]);
    setCartTotalQty("0");
    setSingleOrderOffline(false);
    setSplitActive(false);
    setEnterAmount("");
    localStorage.removeItem("loyaltyPoints");
    localStorage.removeItem("loyaltyDetails");
    localStorage.removeItem("CartId");
    setCartId(null); // sync React context so banner renders immediately
    dispatch(addcoupon("---"));
    setPayLoader(false);
    setCashChange(false);
    setPartailStatus(false);
    const currentStoreMode = localStorage.getItem("storeMode") || "ONLINE";
    localStorage.setItem("cartStoreMode", currentStoreMode);
    setPreviousAmountPaid("");
    setAmountPaid("");
    setPAmt("");
    setSgst("");
    setCess("");

    setCgst("");
    setSubTotal("");
    setAdjustCheck(false);
    setAmountPaid("");
    setTotal("");
    setCartBilling?.(null);
    setTaxes?.([]);
    const customer_details = {
      name: null,
      mobileNumber: null,
      uidx: null,
      whatsapp: false,
    };
    localStorage.setItem("customer_details", JSON.stringify(customer_details));
  };

  const deleteCartItem = () => {
    // customEventTrigger("pos_remove_to_cart", {
    //   value: cartItems.cartProductId,
    // });
    // newSwal.fire({
    //   title: "Are you sure you want to delete the cart?",
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonText: "Proceed",
    //   preConfirm: async () => {
    //     setOpenDelete(true);
    //   },
    //   backdrop: "rgba(0,0,0,0.4)",
    // });

    setOpenDelete(true);
  };

  useEffect(() => {
    const payload = { contextId: locId };
    getManagers(payload).then((res) => {
      const response = res?.data?.data?.map((e) => {
        return {
          value: e?.mobile_number,
          label: e?.first_name,
          uidx: e?.uidx,
        };
      });
      setManagerDetails(response);
    });
  }, []);

  //order metrics api call

  const orderMetricsApiCall = () => {
    if (!isMobile) {
      let totalDiff = 0;

      for (let i = 0; i < productTimeArray.length; i++) {
        totalDiff += productTimeArray[i];
      }

      const averageDiff = totalDiff / productTimeArray.length;
      const currentTime = new Date().getTime();
      const orderTime = currentTime - eventTime.startTime;
      const payload = {
        sessionId: sessionId,
        dayId: daySessionId,
        uidx: uidx,
        manualSearchCount: manuallyAddedProducts,
        barCodeSearchCount: scannedProducts,
        totalItems: totalProducts,
        averageItemTime: averageDiff,
        orderTime: orderTime,
        itemsRemoved: manuallyRemovedItems,
        manualItems: manuallyAddedGtinArray,
      };
      orderMetricsCreate(payload).then((res) => console.log(res));
      dispatch(resetState(0));
      localStorage.setItem("orderMetrics", JSON.stringify({}));
    }
  };

  const offerNewSwal = Swal.mixin({
    customClass: {
      confirmButton: "button button-error",
      cancelButton: "button button-success",
      container: "close-session-swal-container",
    },
    buttonsStyling: false,
  });

  const handleOfferCalculate = async () => {
    if (offerCalculationInFlightRef.current) return;
    offerCalculationInFlightRef.current = true;
    setOfferLoader(true);
    try {
      let cartData = null;
      let itemData = [];
      // The backend applies one offer-product per call, so keep calling until no
      // offer products remain (offerProductFound === false) or a pass makes no
      // progress. Bounded by cart size so offers that can never qualify can't
      // cause an infinite loop.
      const maxPasses = (cartItems?.length || 0) + 5;
      let prevSignature = null;
      for (let pass = 0; pass < maxPasses; pass++) {
        const response = await cartOfferCalculate(CartId);
        cartData = response?.data?.data?.cartData;
        itemData = response?.data?.data?.data || [];
        const pendingOfferKeys = itemData
          .map((ele) =>
            [
              ele?.cartProduct?.gtin || "",
              ele?.cartProduct?.batchNo || "",
              ele?.cartProduct?.mrp || "",
              ele?.cartProduct?.sellingPrice || "",
            ].join("|")
          )
          .sort();
        const signature = JSON.stringify({
          total: cartData?.billing?.totalCartValue,
          qty: cartData?.billing?.quantity,
          items: cartData?.cartProducts?.length,
          pendingOfferKeys,
        });
        if (!cartData?.offerProductFound || signature === prevSignature) {
          break;
        }
        prevSignature = signature;
      }

      setOfferFound(cartData?.offerProductFound);
      setCartItems(cartData?.cartProducts);
      setCartTotalQty(cartData?.billing?.quantity);
      setCartId(cartData?.cartId);
      setCgst(cartData?.billing?.cgst);
      setSgst(cartData?.billing?.sgst);
      setCess(cartData.billing.totalCessAmount);
      setSubTotal(cartData?.billing?.subtotal);
      setTotal(cartData?.billing?.totalCartValue);
      if (cartData?.billing) {
        setCartBilling?.(cartData.billing);
        if (Array.isArray(cartData.billing.taxes)) {
          setTaxes?.(cartData.billing.taxes);
        }
      }
      setIsExploding(true);

      if (itemData.length < 1) {
        handleCloseOfferCheckModal();
        setOfferFound(false);
      }
      const offerList = itemData?.map((ele) => {
        return {
          productName: ele?.cartProduct?.productName,
          productGtin: ele?.cartProduct?.gtin,
          productBatchNo: ele?.cartProduct?.batchNo,
          productMrp: ele?.cartProduct?.mrp,
          productSp: ele?.cartProduct?.sellingPrice,
          availableOfferList: ele?.inventoryResponse?.offersEntityList,
        };
      });
      setOfferListData(offerList);
      if (offerList.length > 0) {
        offerNewSwal
          .fire({
            title: "Offer Found",
            text: `There ${offerList.length === 1 ? "is" : "are"} ${offerList.length} ${
              offerList.length === 1 ? "item" : "items"
            } in your cart which doesn't meet the offer criteria. Would you like to know more about it ?`,
            icon: "info",
            showCancelButton: true,
            cancelButtonText: "Show the Offers",
            confirmButtonText: "Proceed without offer",
            preConfirm: async () => {
              handleCloseOfferCheckModal();
              setOfferFound(false);
            },
            backdrop: "rgba(0,0,0,0.4)",
          })
          .then((result) => {
            if (result.dismiss === "cancel") {
              handleShowoffer();
            }
          });
      }
    } catch (err) {
      showSnackbar(err.message || err?.response?.data?.message, "error");
    } finally {
      offerCalculationInFlightRef.current = false;
      setOfferLoader(false);
    }
  };

  const confettiOptions = {
    force: 0.3,
    duration: 2200,
    particleSize: 12,
    particleCount: 70,
    width: 900,
  };

  useEffect(() => {
    if (isExploding) {
      const timeoutId = setTimeout(() => {
        setIsExploding(false);
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [isExploding]);

  useEffect(() => {
    const handleDeliveryKeyDown = (event) => {
      if (event.ctrlKey && event.key === "a") {
        handleOfferCalculate();
      }
    };
    window.addEventListener("keydown", handleDeliveryKeyDown);
    return () => {
      window.removeEventListener("keydown", handleDeliveryKeyDown);
    };
  }, []);

  const handleShowoffer = () => {
    setShowOffer(true);
    handleOpenOfferCheckModal();
  };

  return (
    <>
      <Navbar>
        <Box className="newGroceryCart">
          <div style={{ position: "relative" }}>
            {isExploding && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  width: "100%",
                  height: "100%",
                  zIndex: 9999,
                }}
              >
                <ConfettiExplosion {...confettiOptions} />
              </div>
            )}
          </div>

          <div className="newGroceryCartContainer">
            <div className="newGroceryCartLeft">
              {/* offer validation */}
              <OfferCheckModal
                offerCheckModal={offerCheckModal}
                handleCloseOfferCheckModal={handleCloseOfferCheckModal}
                setOfferFound={setOfferFound}
                offerListData={offerListData}
                showOffer={showOffer}
              />

              {isExploding && <ConfettiExplosion {...confettiOptions} />}

              {/* this is the left side section of the cart */}
              <TwoWayCartKeyboard
                managerDetails={managerDetails}
                cartItems={cartItems}
                customerMobile={customerMobile}
                handleNewCart={handleNewCart}
                storeMode={storeMode}
                machinenewId={machinenewId}
                deleteCartItem={deleteCartItem}
                openDelete={openDelete}
                setOpenDelete={setOpenDelete}
                deleteLoader={deleteLoader}
                setDeleteLoader={setDeleteLoader}
                cartActive={cartActive}
                isExploding={isExploding}
                setIsExploding={setIsExploding}
              />
            </div>

            <div className="newGroceryCartRight">
              <CartRightSidebar
                presetType="GROCERY_CART"
                buttonHandlers={{
                  searchProducts: {
                    onClick: handleSearchProductModal,
                  },
                  customer: {
                    onClick: handleAddCustomerModalOpen,
                    customerAdded: !!customerMobile,
                    customerName: customerName || customerMobile,
                  },
                  pricingMode: {
                    activated: isPricingModeWholesale,
                    onClick: () => setIsPricingModeWholesale((prev) => !prev),
                  },
                  holdCart: {
                    onClick: () => {
                      if (cartItems.length < 1) {
                        showSnackbar("Add products to the cart to hold.", "info");
                      } else {
                        setHoldCartModalOpen(true);
                      }
                    },
                    visible: cartItems?.length > 0,
                  },
                  loyalty: {
                    onClick: handleLoyaltyModal,
                    disabled: disableLoyalty || isB2BOrder,
                    // Keep the button clickable while disabled for B2B so the
                    // handler can explain why loyalty is unavailable.
                    allowClickWhenDisabled: isB2BOrder,
                  },
                  coupon: {
                    onClick: handleCouponModal,
                    disabled: disableCoupon,
                  },
                  offer: {
                    onClick: handleOfferModalOpen,
                  },
                  clearCart: {
                    onClick: deleteCartItem,
                    visible: cartItems?.length > 0,
                  },
                  paymentConfig: {
                    onClick: handleManagerModalOpen,
                  },
                }}
              />
            </div>

            <SearchBar
              searchOpen={searchOpen}
              setSearchOpen={setSearchOpen}
              closeSearchProductModal={closeSearchProductModal}
            />

            <GroceryAddCustomerModal
              open={open}
              cartItems={cartItems}
              setCartItems={setCartItems}
              setOpenCartCustomerDetail={setOpen}
              setName={setCustomerName}
              setCustomerLoader={() => {}}
              onCustomerAdded={handleLoyaltyCustomerAdded}
              disableClose={disableCustomerModalClose}
            />

            {/* loyalty Modal */}
            <LoyaltyPopupCustom
              loyaltyModal={loyaltyModal}
              handleCloseModal={handleCloseModal}
              setLoyaltyModal={setLoyaltyModal}
              setOpen={setOpen}
              setPendingLoyaltyReopen={() => {
                pendingLoyaltyReopenRef.current = true;
              }}
            />

            {/* Coupon modal */}
            <CouponPopup
              type={"GROCERY"}
              couponsModal={couponsModal}
              setCouponsModal={setCouponsModal}
            />

            {/* offer modal */}
            <OfferListing offerModal={offerModal} handleOfferModalClose={handleOfferModalClose} />

            {/* GST Invoice is now handled via the customer addition modal — no separate drawer needed */}

            {isExploding && <ConfettiExplosion {...confettiOptions} />}

            {/* delivery charge add modal */}
            <DeliveryModal
              handleCloseDeliveryPopUp={handleCloseDeliveryPopUp}
              openDelivery={openDelivery}
            />

            {/*Manager auth modal */}
            <ManagerAuthModal
              // managerDetails={managerDetails}
              managerModal={managerModal}
              storeMode={storeMode}
              setmanagerModal={setmanagerModal}
              handleManagerModalClose={handleManagerModalClose}
              machinenewId={machinenewId}
            />

            {/* payment modal */}
            <PaymentModal
              openPayModal={openPayModal}
              closePaymentModal={closePaymentModal}
              handleOpenPaymentModal={handleOpenPaymentModal}
              cartItems={cartItems}
              billing={cartBilling}
              taxes={taxes || cartBilling?.taxes}
              newLoader={newLoader}
              modalLoader={modalLoader}
              payLoader={payLoader}
              partialStatus={partialStatus}
              paymentMethod={paymentMethod}
              splitActive={splitActive}
              setSplitActive={setSplitActive}
              amtHeading={amtHeading}
              amountDue={amountDue}
              adjustCheck={adjustCheck}
              amtToBePaid={amtToBePaid}
              setPaymentMethod={setPaymentMethod}
              cashIcon={cashNew}
              cashIconSelected={cashNewSelected}
              upiIcon={upiNew}
              upiIconSelected={upiNewSelected}
              cardIcon={cardNew}
              cardIconSelected={cardNewSelected}
              creditIcon={creditNew}
              creditIconSelected={creditNewSelected}
              storeMode={storeMode}
              handleOffline={handleOffline}
              singleOrderoffline={singleOrderoffline}
              offlineImg={offlineImg}
              splitImg={splitNew}
              splitImgSelected={splitNewSelected}
              handleSplitPayment={handleSplitPayment}
              clrAmountFun={clrAmountFun}
              enterAmount={enterAmount}
              setEnterAmount={setEnterAmount}
              enterAmountRef={enterAmountRef}
              setAmtFocus={setAmtFocus}
              total={total}
              cashChange={cashChange}
              handlesplitInputChange={handlesplitInputChange}
              partialCompletePayment={partialCompletePayment}
              checkPayment={checkPayment}
              amountPaid={amountPaid}
              functionCalled={functionCalled}
              createOrderFun={createOrderFun}
              createDebitFun={createDebitFun}
              setFunctionCalled={setFunctionCalled}
              cardFunctionCalled={cardFunctionCalled}
              digitalPaymentFunUPI={digitalPaymentFunUPI}
              setCardFunctionCalled={setCardFunctionCalled}
              setSplitFunctionCalled={setSplitFunctionCalled}
              splitFunctionCalled={splitFunctionCalled}
              paymentLoader={paymentLoader}
              setpaymentLoader={setpaymentLoader}
              paymentLoadingModal={paymentLoadingModal}
              manual={manual}
              transCode={transCode}
              approveloader={approveloader}
              handleManualorders={handleManualorders}
              cashierPin={cashierPin}
              paymentFailed={paymentFailed}
              newId={newId}
              failedImgWarning={failedImgWarning}
              handleTansactionCancel={handleTansactionCancel}
              cancelLoader={cancelLoader}
              paymentSuccess={paymentSuccess}
              isError={isError}
              isPrinting={isPrinting}
              orderId={orderId}
              resetValues={resetValues}
              paymentCancel={paymentCancel}
              cancelGif={cancelGif}
              handleManual={handleManual}
              newTransId={newTransId}
              setOpen={setOpen}
              setPaymentSuccess={setPaymentSuccess}
            />
          </div>

          <div className="groceryFloatingBottomWrapper">
            <FloatingBottom
              customerMobile={customerMobile}
              customerName={customerName}
              coupon={!couponData?.couponValue ? "0" : couponData?.couponValue}
              loyalty={!loyaltyPoints ? "0" : loyaltyPoints}
              amountArray={amountArray}
              isSalesOrder={isSalesOrder}
              saleMode={saleMode}
              offerFound={offerFound}
              cartItems={cartItems}
              total={total}
              normalizeNumber={normalizeNumber}
              partialStatus={partialStatus}
              adjustCheck={adjustCheck}
              splitActive={splitActive}
              amtToBePaid={amtToBePaid}
              amountPaid={amountPaid}
              amtHeading={amtHeading}
              handleOfferCalculate={handleOfferCalculate}
              handleOpenPaymentModal={handleOpenPaymentModal}
              handleDeliveryPopUp={handleDeliveryPopUp}
              createOrderFun={createOrderFun}
              offerLoader={offerLoader}
              isPlacingDelivery={isPlacingDelivery}
              loaderAdj={loaderAdj}
              cartId={cartId}
              onAddCustomer={() => setOpen(true)}
              cartTotalQty={cartTotalQty}
            />
          </div>
        </Box>
        <HoldCartModal
          open={holdCartModalOpen}
          onClose={() => setHoldCartModalOpen(false)}
          cartId={cartId}
          cartItems={cartItems}
          total={total}
          onViewHeldOrders={() => setHoldOrderDrawerOpen(true)}
          onHoldSuccess={() => {
            dispatch(incrementHoldOrdersCount(cartItems?.length));
            dispatch(resetState(0));
            dispatch(addtoggleMode(true));
            localStorage.removeItem("loyaltyPoints");
            localStorage.setItem("orderMetricData", JSON.stringify({}));
            localStorage.removeItem("CartId");
            handleOpen();
          }}
        />
        <HoldOrderDrawer open={holdOrderDrawerOpen} onClose={() => setHoldOrderDrawerOpen(false)} />
      </Navbar>
    </>
  );
};

export default GroceryCart;
